// Copyright 2021 Merit International Inc. All Rights Reserved
import { BaseTheme } from "../base";
import merge from "lodash.merge";
import type { PartialTheme, Theme } from "../types";

const LightTheme: Theme = merge<Record<string, never>, Theme, PartialTheme>({}, BaseTheme, {});

export { LightTheme };
